export default () => {
  let firstPost = document.querySelector('#post_feed_top')

  if(firstPost){
    window.scrollBy(0, 10);
  }  
};
